import React, { ChangeEvent, FocusEvent, FC } from 'react'
import MaskedInput, { conformToMask } from 'react-text-mask'

interface Props {
  name: string
  value: string
  title?: string
  placeholder?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => {}
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
}

const phoneMask = [
  /[1-9]/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

const stripChars = (str) => str.replace(/[^\d]/gi, '')

const TelephoneInput: FC<Props> = ({
  name,
  value = '',
  placeholder,
  onChange,
  onBlur = (e) => {},
  ...rest
}) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = stripChars(e.target.value)
      const newEvent: React.ChangeEvent<HTMLInputElement> = {
        ...e,
        target: {
          ...e.target,
          name,
          value,
        },
      }
      onChange(newEvent)
    },
    [name, onChange]
  )

  const pipe = React.useCallback(
    (conformedValue, { rawValue }) => {
      // if number is already 10 digits, or new value is empty, return conformed value
      // otherwise we're pasting or autofilling and need to slice to 10 digits and mask
      // to remove country codes etc
      return value?.length === 10 || !rawValue
        ? conformedValue
        : conformToMask(rawValue.replace(/\D/g, '').slice(-10), phoneMask)
            .conformedValue
    },
    [value]
  )

  return (
    <MaskedInput
      mask={phoneMask}
      type="tel"
      value={value}
      autoComplete={'off'}
      name={name}
      className="input__field fs-exclude"
      onChange={handleChange}
      onBlur={onBlur}
      placeholder={placeholder}
      pipe={pipe}
      {...rest}
    />
  )
}

export default TelephoneInput
